import type { Coffee } from "../types";

export function photoUrl(key: string | null | undefined): string | null {
  return key ? `/api/photos/${key}` : null;
}

export function primaryPhotoUrl(coffee: Pick<Coffee, "photos" | "photo_url">): string | null {
  const first = coffee.photos?.[0]?.r2_key;
  return photoUrl(first ?? coffee.photo_url ?? null);
}
